<h1 mat-dialog-title [innerHTML]="data.title"></h1>
<div mat-dialog-content [innerHTML]="data.description"></div>
<div mat-dialog-actions>
  <button mat-button (click)="data.onConfirm()">Ok</button>
  <button mat-button mat-dialog-close>Cancel</button>
</div>